import React from 'react';
import './styles.css';

const Loader = () => {
  return <div className="loader_2">Loading...</div>;
};

export default Loader;
